import { ChatStatusEnum } from '@/entities/feedbacks'
import { Avatar, Button, Skeleton, Space, Typography } from 'antd'
import { useUnit } from 'effector-react'

import { AVATAR_SIZE } from '../../lib/constants'
import {
  $feedbackChatStatus,
  $isFeedbackChangeStatusPending,
  feedbackChatClosed,
  feedbackChatQuery,
} from '../../model/feedback-chat.model'
import { CardHeader } from '../CardHeader'

export function FeedbackChatHeader() {
  const feedbackChatQueryMetadata = useUnit(feedbackChatQuery)
  const [
    handleClickCloseFeedbackChat,
    feedbackChatStatus,
    isFeedbackChangeStatusPending,
  ] = useUnit([
    feedbackChatClosed,
    $feedbackChatStatus,
    $isFeedbackChangeStatusPending,
  ])

  return (
    <CardHeader>
      {feedbackChatQueryMetadata.data ? (
        <>
          <Space size="middle">
            <Avatar
              size={AVATAR_SIZE}
              src={feedbackChatQueryMetadata.data.chatPartnerAvatar?.fullS3Url}
            />

            <Typography.Text strong ellipsis>
              {feedbackChatQueryMetadata.data.name}
            </Typography.Text>
          </Space>
          <Button
            onClick={handleClickCloseFeedbackChat}
            loading={isFeedbackChangeStatusPending}
            disabled={feedbackChatStatus === ChatStatusEnum.Closed}
          >
            Закрыть обращение
          </Button>
        </>
      ) : feedbackChatQueryMetadata.pending ? (
        <>
          <Space size="middle">
            <Skeleton.Avatar size={AVATAR_SIZE} />
            <Skeleton.Input active size="small" />
          </Space>
          <Skeleton.Button />
        </>
      ) : null}
    </CardHeader>
  )
}
